var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdTimeInf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_172_2",
    "data-name": "Component 172 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 74,
    height: 75,
    rx: 6,
    fill: "#0b0b12"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M51.017,141.75a12.644,12.644,0,0,0-21.585-8.941L16.568,145.674a5.549,5.549,0,1,1,0-7.848l1.81,1.81,5.017-5.017-1.81-1.81a12.644,12.644,0,1,0,0,17.881l12.865-12.865a5.549,5.549,0,1,1,0,7.847l-1.81-1.81-5.017,5.017,1.81,1.81a12.644,12.644,0,0,0,21.585-8.94Z",
    transform: "translate(11.492 -104.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdTimeInf);
export default __webpack_public_path__ + "static/media/prodTimeInf.82a27bbcda9305b7f2a1326df4bcdf27.svg";
export { ForwardRef as ReactComponent };